import React, { useState, useEffect } from 'react';
import { reaction } from 'mobx'
import { observer } from 'mobx-react'
import { Popover, Checkbox, Button, Icon } from '@tinper/next-ui'
import render from 'ynf-core-engine/render'

import { getFieldId, arraysContain, getNodeChildren } from '../../utils/tools';
import { getRefReturn } from '../../utils/formatter';
import './index.less';

const DropDown = observer((props: any) => {
  const { inputProps, referRootStore, referRef, focused } = props
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (focused) {
      setVisible(true)
      referRootStore.searchData({ type: 'dropDown' })
    }
  }, [focused])

  const hide = () => {
    setVisible(false)
  }

  return <Popover
    fieldid={`${getFieldId(inputProps)}_dropdown`}
    hideArrow={false}
    rootClose={true}
    // getPopupContainer={() => referRef.current}
    placement='bottomLeft'
    destroyTooltipOnHide={false}
    trigger='click'
    overlayClassName="ynf-refer-popover"
    visible={visible}
    onHide={hide}
    content={<div className='smartsearch-table' style={{ width: referRef.current?.offsetWidth }}>{referRootStore.refEntity.cTpltype == 'Tree' ? <DropDownTree {...props} hide={hide} /> : <DropDownTable {...props} hide={hide}/>}</div>}>
  </Popover>
})

// 下拉表样式 table/ treetable
const DropDownTable = observer((props: any) => {
  const { inputProps, referRootStore } = props
  const keyField = referRootStore.cEntityKeyFld
  const defaultVal = inputProps.multiple ? inputProps.value?.map((e: any) => e[keyField]) : [inputProps.value?.[keyField]]
  const refReturn = getRefReturn(inputProps); // 显示值

  const [loding, setLoding] = useState(false)
  const [selectAll, setSelectAll] = useState(false)
  const [dataSource, setDataSource] = useState([])
  const [checkArr, setCheckArr] = useState(defaultVal || [])
  const [filterDataSource, setFilterDataSource] = useState([])

  useEffect(() => {
    const search = reaction(() => referRootStore.referStore.searchFlag, (newVal: any) => {
      if (newVal.type === 'init') {
        setLoding(true) // 开始搜索
      }
    })

    const getDataSource = reaction(() => referRootStore.tableStore.getValue(), (newVal: any) => {
      const value = newVal.map((e: any) => ({ ...e.data }))
      setLoding(false)
      setDataSource(value)
    })

    return () => {
      search()
      getDataSource()
    }
  }, [])

  useEffect(() => {
    if (Array.isArray(inputProps.value)) { // 多选
      if (inputProps.value.length !== checkArr.length) {
        setCheckArr(inputProps.value.map((e:any) => e[keyField]))
        setSelectAll(false)
      }
    } else { // 单选
      (Object.keys(inputProps.value || {}).length === 0) && setCheckArr([])
    }
  }, [inputProps.value])

  useEffect(() => {
    if (props.inputValue) {
      const filter = dataSource.filter((e: any) => {
        return refReturn.some((ele: any) => {
          return e[ele].toString().includes(props.inputValue);
        });
      })
      setFilterDataSource(filter)
    }
  }, [props.inputValue])

  useEffect(() => {
    referRootStore.tableStore?.setSelectRowKeys(checkArr);
  }, [checkArr])

  const onCheckedAll = (check: any) => { // 全选
    setSelectAll(check)
    if (check) { // 全选
      const allKey = dataSource.map((e: any) => e[keyField])
      setCheckArr(allKey)
    } else { // 反选
      setCheckArr([])
    }
  }

  const confirm = () => { // 确定
    const value = dataSource.filter((e: any) => checkArr.includes(e[keyField]))
    referRootStore.setData(value)
    props.hide()
  }

  const cancel = () => { // 取消
    props.hide()
  }

  const getItemText = (val: any) => { // 组装显示的item值
    let text = '';
    refReturn.forEach((item: any, index: any) => {
      if (index !== 0) {
        text += '-' + val[item];
      } else {
        text += val[item];
      }
    })
    let result: any = '';
    if (text.indexOf(props.inputValue) > -1 && props.inputValue) {
      const rtext = text.replace(props.inputValue, '%$#@!%') // 分隔符
      const textList = rtext.split('%$#@!%')
      result = <span>
        {textList[0]}
        <span style={{ color: 'red' }}>{props.inputValue}</span>
        {textList[1]}
      </span>
    } else {
      result = text
    }
    const isChecked = checkArr.includes(val[keyField]);
    if (inputProps.dataMultiple) { // 多选
      return <Checkbox checked={isChecked} onChange={() => { selectItem(val) }} fieldid={`${getFieldId(inputProps)}_dropdown_checkbox`}>{result}</Checkbox>
    } else {
      return <>{result}{isChecked && <Icon type="uf-correct-2" />}</>
    }
  }

  const selectItem = (val: any) => { // 点击选择数据
    const keyVal = val[keyField]
    if (inputProps.dataMultiple) { // 多选
      if (checkArr.includes(keyVal)) {
        const deleteIndex = checkArr.indexOf(keyVal);
        checkArr.splice(deleteIndex, 1)
        setCheckArr([...checkArr])
      } else {
        setCheckArr([...checkArr, keyVal])
      }
    } else { // 单选
      referRootStore.setData([val])
      setCheckArr([keyVal])
      props.hide()
    }
  }

  const renderSelectList = (data: any) => {
    return data.map((item: any, idx: number) => {
      const text = getItemText(item)
      let style = {};
      if (checkArr.includes(item[keyField])) {
        style = { background: '#E9F0FA' }
      }
      return <div key={idx} className='list-item' onClick={() => { selectItem(item) }} style={style} fieldid={`${getFieldId(inputProps)}_dropdown_select`}>{text}</div>
    })
  }

  const renderList = () => {
    if (loding) {
      return <div className='loading'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_191B4C4605200011', '加载中...', undefined, {returnDom: true, placement: 'top'})}</div>
    }
    if (dataSource.length > 0 && props.inputValue && filterDataSource.length > 0) {
      return renderSelectList(filterDataSource)
    } else if (dataSource.length > 0 && props.inputValue) {
      return <div className='loading'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_194309500558000B', '暂无搜索结果', undefined, {returnDom: true, placement: 'top'})}</div>
    } else if (dataSource.length > 0) {
      return renderSelectList(dataSource)
    } else {
      return <div className='loading'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_194309500558000C', '暂无数据', undefined, {returnDom: true, placement: 'top'})}</div>
    }
  }

  return (
    <div>
      <div className='refer-dropdown-box'>{renderList()}</div>
      {
        inputProps.dataMultiple && 
        <div className='yyrefer-popover-btn'>
          <Checkbox checked={selectAll} onChange={onCheckedAll} fieldid={`${getFieldId(inputProps)}_dropdown_selectall`}>
            {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_194309500558000D', '全选', undefined, {returnDom: true, placement: 'top'})}
          </Checkbox>
          <div>
            <Button className="cancel" onClick={cancel} colors="secondary" fieldid={`${getFieldId(inputProps)}_dropdown_cancle`}>
              {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_194309500558000A', '取消', undefined, {returnDom: true, placement: 'top'})}
            </Button>
            <Button onClick={confirm} colors='primary' fieldid={`${getFieldId(inputProps)}_dropdown_ok`}>
              {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0002F', '确定', undefined, {returnDom: true, placement: 'top'})}
            </Button>
          </div>
        </div>
      }
    </div>
  )
})

// 下拉树形式 tree  treelist(未加)
const DropDownTree = observer((props: any) => {
  const { inputProps, referRootStore } = props
  const keyField = referRootStore.cEntityKeyFld
  const treeMap = referRootStore.treeStore.keyMap
  const defaultVal = inputProps.multiple ? inputProps.value.map((e: any) => e[keyField]) : [inputProps.value[keyField]]
  const refReturn = getRefReturn(inputProps); // 显示值

  const [loding, setLoding] = useState(false)
  const [selectAll, setSelectAll] = useState(false)
  const [dataSource, setDataSource] = useState(false)
  const [filterDataSource, setFilterDataSource] = useState([])
  const [checkArr, setCheckArr] = useState(defaultVal || [])

  useEffect(() => {
    const search = reaction(() => referRootStore.treeStore.searchFlag, (newVal: any) => {
      if (newVal.type === 'init') {
        setLoding(true) // 开始搜索
      }
    })

    const getDataSource = reaction(() => referRootStore.treeStore.getValue(), (newVal: any) => {
      setLoding(false) // 开始搜索
      setDataSource(newVal)
    })

    return () => {
      search()
      getDataSource()
    }
  }, [])

  useEffect(() => {
    if (Array.isArray(inputProps.value)) { // 多选
      if (inputProps.value.length !== checkArr.length) {
        setCheckArr(inputProps.value.map((e:any) => e[keyField]))
        setSelectAll(false)
      }
    } else { // 单选
      (Object.keys(inputProps.value || {}).length === 0) && setCheckArr([])
    }
  }, [inputProps.value])

  useEffect(() => {
    if (props.inputValue) {
      const filter = dataSource.filter((e: any) => {
        return refReturn.some((ele: any) => {
          return e[ele].toString().includes(props.inputValue);
        });
      })
      setFilterDataSource(filter)
    }
  }, [props.inputValue])

  const onCheckedAll = (check: any) => { // 全选
    setSelectAll(check)
    if (check) { // 全选
      const allKey = Object.keys(treeMap)
      setCheckArr(allKey)
    } else { // 反选
      setCheckArr([])
    }
  }

  useEffect(() => {
    referRootStore.treeStore?.onExCheck(checkArr);
  }, [checkArr])

  const confirm = () => { // 确定
    const value = checkArr.map((e: any) => treeMap[e])
    referRootStore.setData(value)
    props.hide()
  }

  const cancel = () => { // 取消
    props.hide()
  }

  const getTreeConfig = () => {
    const { fieldid, fieldidPrefix, multiple } = inputProps;
    return {
      store: { // 树数据
        dataSource: props.inputValue.length > 0 ? filterDataSource : dataSource
      },
      fieldid,
      fieldidPrefix,
      libCode: 'ynf-lib-base', // 组件库
      controlType: 'Tree', // 组件类型
      alias: 'refer-dropDown-tree', // 组件唯一标识
      checkable: inputProps.multiple, // 节点前添加 Checkbox 复选框
      titleField: inputProps.textField, // 显示的字段名
      keyField: keyField, // key取值的字段名
      checkedKeys: checkArr, // 选中复选框的树节点
      selectedKeys: checkArr, // 设置选中的树节点
      // expandedKeys: expandedKeys, // 展开指定的树节点
      checkStrictly: true, // checkable 状态下节点选择完全受控（父子节点选中状态不再关联）
      searchValue: props.inputValue, // 查询的关键词(高亮样式用)
      showButton: inputProps.multiple, // 多选树时展示包含同级/包含下级按钮
      selectable: true,
      showLine: true, // 是否显示连接线
      showAddNode: false,
      onCheck: (val: any) => {
        setCheckArr(val)
      },
      onSelect: (val: any) => {
        val = val[0]
        if (multiple) {
          if (checkArr.includes(val)) {
            const deleteIndex = checkArr.indexOf(val);
            checkArr.splice(deleteIndex, 1)
            setCheckArr([...checkArr])
          } else {
            setCheckArr([...checkArr, val])
          }
        } else {
          setCheckArr([val])
          referRootStore.setData([referRootStore.treeStore.keyMap[val]])
          props.hide()
        }
      },
      sameLevelClick: (val: any) => { // 包含同级
        const broList = Object.values(treeMap).filter((e: any) => e.level === val.level).map((e: any) => e[keyField])
        if (arraysContain(checkArr, broList)) { // 包含
          setCheckArr(checkArr.filter((e: any) => !broList.includes(e)))
        } else { // 不包含
          setCheckArr([...new Set([...checkArr, ...broList])])
        }
      },
      nextLevelClick: (val: any) => { // 包含下级
        const children = [val[keyField], ...getNodeChildren(val, keyField)]
        if (arraysContain(checkArr, children)) { // 包含
          setCheckArr(checkArr.filter((e: any) => !children.includes(e)))
        } else { // 不包含
          setCheckArr([...new Set([...checkArr, ...children])])
        }
      }
    }
  }

  const renderTree = () => {
    if (loding) {
      return <div className='loading'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1943095005580013', '加载中...', undefined, {returnDom: true, placement: 'top'})}</div>
    }
    if (dataSource.length && props.inputValue && filterDataSource.length) {
      return render(getTreeConfig(), { rootStore: {} })
    } else if (loding && dataSource.length && props.inputValue) {
      return <div className='loading'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1943095005580010', '暂无搜索结果', undefined, {returnDom: true, placement: 'top'})}</div>
    } else if (dataSource.length) {
      return render(getTreeConfig(), { rootStore: {} })
    } else {
      return <div className='loading'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1943095005580011', '暂无数据', undefined, {returnDom: true, placement: 'top'})}</div>
    }
  }

  return (
    <>
      <div className='refer-dropdown-box'>{renderTree()}</div>
      {
        inputProps.multiple &&
        <div className='yyrefer-popover-btn'>
          <Checkbox checked={selectAll} onChange={onCheckedAll} fieldid={`${getFieldId(inputProps)}_tree_selectall`}>
            {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_194309500558000F', '全选', undefined, {returnDom: true, placement: 'top'})}
          </Checkbox>
          <div>
            <Button className="cancel" onClick={cancel} colors="secondary" fieldid={`${getFieldId(inputProps)}_tree_cancle`}>
              {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1943095005580012', '取消', undefined, {returnDom: true, placement: 'top'})}
            </Button>
            <Button onClick={confirm} colors='primary' fieldid={`${getFieldId(inputProps)}_tree_ok`}>
              {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C0002F', '确定', undefined, {returnDom: true, placement: 'top'})}
            </Button>
          </div>
        </div>
      }
    </>
  )
})

export default React.memo(DropDown, (preProps: any, props: any) => {
  return preProps.focused === props.focused && preProps.inputValue === props.inputValue
})
